<template>
  <div class="inner">
    <h2>Смените аккаунт</h2>
    <p>
      Для того, чтобы оставить отзыв, забронировать стол или добавить заведение
      в избранное необходимо выйти из бизнес-аккаунта и войти в
      пользовательский.
    </p>
    <div class="buttons">
      <AsyncButton class="button" @click="accept">
        Войти под другим аккаунтом
      </AsyncButton>
    </div>
    <IconPopupCross
      v-if="screenWidth !== 'mobile'"
      class="modal-cross"
      @click="closeModal"
    />
  </div>
</template>

<script setup>
import { computed, onBeforeUnmount } from "vue";
import { useStore } from "vuex";

const store = useStore();

const screenWidth = computed(() => {
  return store.getters.screenType;
});

onBeforeUnmount(() => {
  store.commit("setIsChangeAccountModalClosed");
});
</script>

<script>
import AsyncButton from "@/components/ui/AsyncButton";
import AuthLogin from "@/components/modals/auth/AuthLoginModal.vue";
import IconPopupCross from "@/components/icons/IconPopupCross.vue";

export default {
  name: "ChangeRoleModal",

  components: {
    IconPopupCross,
    AsyncButton,
  },

  computed: {
    data() {
      return this.$store.state.biz_booking.bookingModal;
    },
  },

  methods: {
    async accept() {
      await this.$store.dispatch("logout");
      this.$router.push("/map");
      this.$store.dispatch("openModal", {
        value: {
          component: AuthLogin,
          props: null,
        },
      });
    },
    closeModal() {
      this.$store.dispatch("closeModal");
    },
  },
};
</script>

<style lang="scss" scoped>
.inner {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 448px;
  margin: auto;
  padding: 32px 56px 40px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;

  @media screen and (max-width: 841px) {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    max-width: 100%;
    box-shadow: 0 -2px 10px 0 #0000000d;
    border-radius: 20px 20px 0 0;
    padding: 32px 24px 24px 24px;
  }
}

h2 {
  margin-bottom: 24px;
  text-align: center;
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  color: #f0811e;
}

p {
  width: 100%;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  color: #222222;
}

.buttons {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  margin-top: 32px;
}

.button {
  width: 100%;
  min-width: 100%;
}

.modal-cross {
  position: absolute;
  top: 25px;
  right: 25px;
  cursor: pointer;
}
</style>
